import React from 'react';
import WorkOrdersBoardPage from './WorkOrdersBoardPage';

const List: React.FC = () => <WorkOrdersBoardPage />;

export default List;
